import React from 'react'
import { useTranslation } from 'next-i18next'
import { CheckoutPage } from '../../../src/model'
import { Head, ApprovedCredit, Footer, HeaderCloseButton } from '../../../src/component'
import { TrackingEvent } from '../../../src/model/monitoring'
import { useCreateFacilityAssessmentMutation } from '../../../src/state'
import { TrackOnMount } from '../../../src/integrations/monitoring'

export const ApprovedCreditPage: CheckoutPage = () => {
  const { t } = useTranslation()

  const pageTitle = `${t('consumerLending:approvedCredit:documentTitle')} | ${t('common:brandName')}`

  const [_, { data: facilityAssessmentData }] = useCreateFacilityAssessmentMutation({ fixedCacheKey: 'shared-facility-assessment' })
  const { facilityLimit, aprRangeMax, aprRangeMin } = facilityAssessmentData ?? {}

  return (
    <>
      <Head title={pageTitle} setMobileStatusBarColor='#000000' />
      <HeaderCloseButton heroCloseButtonColour='White' />
      <ApprovedCredit />
      <Footer visible />
      <TrackOnMount
        eventName={TrackingEvent.VIEWED_CL_APPROVED_CREDIT_PAGE}
        eventProperties={{
          facilityLimit,
          aprRangeMax,
          aprRangeMin,
        }}
      />
    </>
  )
}
